import React, { useState } from "react";
import Timeline from "./Timeline";

export default function Experiences() {
  const [educationData] = useState([
    {
      id: 1,
      name: "Universitas Pelita Harapan",
      timeline: "2017 - 2021 (3.4 out of 4 GPA)",
      location: "Tangerang, Indonesia",
      desc: "Information Systems",
      current: false,
    },
    {
      id: 2,
      name: "SMA Pelita Nusantara Tanjungpinang",
      timeline: "Graduated on 2017",
      location: "Tanjungpinang, Indonesia",
      desc: "",
      current: false,
    },
  ]);

  const [workExperienceData] = useState([
    {
      id: 1,
      name: "Software Engineer at Goto Group (Gojek)",
      timeline: "June 2025 - Now",
      location: "Jakarta, Indonesia",
      jobType: "Full-time",
      workMode: "On-site",
      desc: "Part of the merchant platform team. Design, build, and optimize large-scale merchant platform services capable of handling millions of merchant records with high availability and low latency.",
      current: true,
    },
    {
      id: 2,
      name: "AI Software Engineer at Trilogy",
      timeline: "June 2025 - January 2026",
      location: "United States",
      jobType: "Contract",
      workMode: "Remote",
      desc: "Contributed as a core member of the cost optimization team, identifying and implementing technical and architectural improvements, resulted in approximately USD 3 million in annual cost savings through system optimization, performance improvements, and operational efficiencies.",
      current: false,
    },
    {
      id: 3,
      name: "Software Engineer at ByteDance (Tokopedia & TikTok Shop)",
      timeline: "May 2022 - June 2025",
      location: "Jakarta, Indonesia",
      jobType: "Full-time",
      workMode: "On-site",
      desc: "Mainly develop, maintain and improve platform software systems. As a part of search team, collaborate across teams to create solutions that enhance the search experience to drive the business growth.",
      current: false,
    },
    {
      id: 4,
      name: "Software Engineer at Bank Sinarmas",
      timeline: "July 2021 - May 2022",
      location: "Jakarta, Indonesia",
      jobType: "Full-time",
      workMode: "On-site",
      desc: "Develop and evaluate the company's software application to ensure that it is valid, is properly structured, meets industry standards, and is well integrated with each other.",
      current: false,
    },
    {
      id: 5,
      name: "Full Stack Engineer at Gandiwa Nusantara",
      timeline: "January 2021 - July 2021",
      location: "Jakarta, Indonesia",
      jobType: "Full-time",
      workMode: "On-site",
      desc: "Develop and Maintain Company's Website. Responsible for implementing visual elements that users see and interact with in a web application and ensuring websites are accessible across many platforms, including laptops and smartphones.",
      current: false,
    },
  ]);

  return (
    <section id="experiences">
      <div className="py-10">
        <h3 className="font-bold text-3xl">
          <span className="text-teal-500">My</span> Experiences
        </h3>

        <div className="flex flex-col lg:flex-row mt-12 gap-12 lg:gap-16">
          <div className="flex-1">
            <h4 className="font-bold text-2xl">Education</h4>
            <ol className="relative border-l border-gray-700 mt-6">
              {educationData.map((data) => (
                <Timeline data={data} type="education" key={data.id} />
              ))}
            </ol>
          </div>
          <div className="flex-1">
            <h4 className="font-bold text-2xl">Work Experience</h4>
            <ol className="relative border-l border-gray-700 mt-6">
              {workExperienceData.map((data) => (
                <Timeline data={data} type="work" key={data.id} />
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}
